import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";

const StorePickupList = () =>
  request({
    url: ApiURL.Query.StorePickupList,
    method: RequestType.GET,
  });
   const StoreList=()=>request({
    url: ApiURL.Query.StoreList,
    method: RequestType.GET,
   });

const FilterStorePickup = (data: any) =>
  request({
    url: ApiURL.Query.FilterStorePickup,
    method: RequestType.POST,
    data,
  }); 

  const ListOfStoreList = () =>
  request({
    url: ApiURL.Query.StoreList,
    method: RequestType.GET,
  }); 

  const GetOperationFlagValue = () =>
  request({
    url: ApiURL.Query.GetOperationFlagValue,
    method: RequestType.GET,
  }); 

  const GetStoreCity = () =>
  request({
    url: ApiURL.Query.GetStoreCity,
    method: RequestType.GET,
  }); 
  
  const GetStoreCounty = (data:any) =>
  request({
    url: ApiURL.Query.GetStoreCounty+"/"+data,
    method: RequestType.GET,  
   //data
  }); 
  const GetStore = (data: any): Promise<any>  =>

 
  request({
    url: ApiURL.Query.GetStore ,
    method: RequestType.GET,  
    params:data,
  }); 
  const ServiceManagment=()=>request({
    url: ApiURL.Query.GetServiceManagment,
    method: RequestType.GET,
   });

   
const OmnichannelQuery = {
  StorePickupList,
  FilterStorePickup,
  ListOfStoreList,
  StoreList,
  ServiceManagment,
  GetOperationFlagValue,
  GetStoreCity,
  GetStoreCounty,
  GetStore
};

export default OmnichannelQuery;
